// 태그용 이모지 빠른 선택 목록 — 자유 입력도 가능하니 자주 쓰는 것만 큐레이션.
export const TAG_EMOJIS = [
  '💼', '📚', '🏋️', '🎮', '🎨', '🍽️', '✈️', '🏠',
  '💊', '💰', '🎉', '❤️', '🐾', '🚗', '🛒', '📌',
];
